import React, { PureComponent } from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';

import Form from '../../components/Admins/Form';
import Spinner from '../../components/Spinner';
import PageTitle from '../../components/PageTitle';
import BackButton from '../../components/BackButton';
import Snackbar from '../../containers/SnackbarContainer';

class NewAdmin extends PureComponent {
  render() {
    const { createAdmin, isFetching, error } = this.props;

    return (
      <Grid container alignItems="center">
        <Grid item>
          <BackButton history={this.props.history} />
        </Grid>
        <Grid item xs={12}>
          <PageTitle> Nuevo Administrador </PageTitle>
        </Grid>
        <Grid item xs={12}>
          <Form
            editable
            onSubmit={createAdmin}
            errors={error.errors}
            passwords
          />
        </Grid>
        { isFetching && <Spinner /> }
        <Snackbar />
      </Grid>
    );
  }
}

export default NewAdmin;

NewAdmin.propTypes = {
  error: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  createAdmin: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/Admins/NewAdmin.js